module.exports = __webpack_public_path__ + "static/media/header-item-favorites.b5e8d056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/header-item-favorites.svg
// module id = 1556
// module chunks = 0